/* Virtueller Wald: Landschaft (Claude 03.11.2026, Leslie). Rein rechnerisch, ohne Speicher: jede Zelle ergibt sich aus Zeile/Spalte. Laeuft im Browser und in Node (Aufteilung der Firmenhaine). ES5. */
(function (root) {
  "use strict";
  var COLS = 1000, ROWS = 900, CW = 38, CH = 28;
  var T_OUT = 0, T_TREE = 1, T_PATH = 2, T_LAKE = 3, T_GRASS = 4, T_SHORE = 5;

  function imul(a, b) { var ah = (a >>> 16) & 0xffff, al = a & 0xffff, bh = (b >>> 16) & 0xffff, bl = b & 0xffff; return ((al * bl) + (((ah * bl + al * bh) << 16) >>> 0) | 0); }
  function hash(c, r) { var h = imul(c * 374761393 + r * 668265263 | 0, 1274126177); h = imul(h ^ (h >>> 13), 1103515245); return (h ^ (h >>> 16)) >>> 0; }
  function fade(t) { return t * t * (3 - 2 * t); }
  function vn(x, y) {
    var xi = Math.floor(x), yi = Math.floor(y), fx = fade(x - xi), fy = fade(y - yi);
    var a = hash(xi, yi) / 4294967295, b = hash(xi + 1, yi) / 4294967295, c = hash(xi, yi + 1) / 4294967295, d = hash(xi + 1, yi + 1) / 4294967295;
    return (a + (b - a) * fx) * (1 - fy) + (c + (d - c) * fx) * fy;
  }
  function fbm(x, y) { return vn(x, y) * 0.65 + vn(x * 2.3 + 7, y * 2.3 + 3) * 0.35; }

  // Areale: Name, Lage (0..1), Baumarten-Gewichte Eiche, Buche, Fichte, Birke
  var AREAS = [
    ["Forsthaus-Hain", .50, .50, 4, 3, 1, 2], ["Eichenhang", .38, .42, 9, 1, 0, 1], ["Buchengrund", .61, .40, 1, 9, 1, 1], ["Birkenlichtung", .62, .60, 1, 2, 0, 9],
    ["Annes Hain", .40, .61, 4, 4, 2, 3], ["Fichtenhöhe", .50, .30, 1, 1, 9, 1], ["Am Waldsee", .27, .50, 3, 3, 1, 5], ["Sonnenhang", .74, .50, 6, 2, 1, 4],
    ["Moosgrund", .50, .71, 2, 6, 4, 1], ["Eulenruh", .30, .30, 6, 3, 3, 0], ["Spechtwinkel", .71, .29, 7, 3, 0, 2], ["Rehwiese", .72, .71, 3, 2, 1, 7],
    ["Igelgrund", .29, .72, 4, 7, 1, 1], ["Fuchsbau", .42, .17, 3, 2, 8, 1], ["Hasenwinkel", .60, .17, 2, 5, 1, 6], ["Waldfrieden", .86, .39, 5, 6, 1, 1],
    ["Kuckucksruf", .87, .62, 3, 3, 6, 2], ["Hirschsprung", .14, .39, 2, 1, 9, 1], ["Nebelgrund", .14, .62, 2, 7, 3, 2], ["Bärlauchtal", .40, .84, 3, 9, 0, 2],
    ["Dachsbau", .60, .84, 6, 2, 3, 1], ["Morgenrot", .80, .18, 3, 2, 2, 7], ["Abendsonne", .21, .18, 7, 2, 1, 3], ["Wichtelwald", .80, .83, 2, 2, 8, 2],
    ["Zukunftshain", .20, .83, 3, 3, 3, 3]
  ];
  var SEEDS = [], i;
  for (i = 0; i < AREAS.length; i++) SEEDS.push([AREAS[i][1] * COLS, AREAS[i][2] * ROWS]);
  // Reihenfolge des Pflanzens: von der Mitte nach aussen = vom aeltesten zum juengsten Areal
  var ORDER = [], RANK = [];
  for (i = 0; i < AREAS.length; i++) ORDER.push(i);
  ORDER.sort(function (a, b) {
    var da = Math.pow(AREAS[a][1] - .5, 2) + Math.pow(AREAS[a][2] - .5, 2), db = Math.pow(AREAS[b][1] - .5, 2) + Math.pow(AREAS[b][2] - .5, 2);
    return da - db;
  });
  for (i = 0; i < ORDER.length; i++) RANK[ORDER[i]] = i;

  var LAKES = [[.205, .545, 34, 25], [.565, .735, 22, 17], [.84, .25, 21, 16], [.35, .135, 17, 14]];
  var GLADES = [[.50, .50, 13, 11], [.345, .335, 8, 7], [.665, .315, 7, 6], [.695, .655, 9, 7], [.345, .665, 8, 6], [.50, .235, 7, 6], [.135, .30, 8, 7], [.885, .50, 9, 7], [.47, .86, 8, 7], [.76, .875, 7, 6], [.235, .80, 8, 7], [.09, .50, 6, 6], [.60, .50, 7, 5], [.42, .50, 6, 5]];

  // Doerfer: Lichtungen an den Wegen zwischen den Arealen (Name, Lage, Halbachsen in Zellen)
  var VILLAGES = [["Eichenrode", .434, .364, 12, 10], ["Buchenbach", .667, .448, 13, 11], ["Birkenhausen", .564, .651, 12, 10], ["Eulenbach", .285, .398, 11, 9], ["Hasenrode", .655, .23, 11, 9], ["Rehbach", .799, .661, 13, 11], ["Igelsbach", .345, .778, 12, 10], ["Tannrode", .309, .16, 11, 9], ["Wichtelhausen", .696, .833, 12, 10]];
  function villageAt(c, r) {
    for (var v = 0; v < VILLAGES.length; v++) { var B = VILLAGES[v]; if (inBlob(c, r, [B[1], B[2], B[3], B[4]], 1)) return v; }
    return -1;
  }
  function inBlob(c, r, b, k) {
    var dx = (c - b[0] * COLS) / b[2], dy = (r - b[1] * ROWS) / b[3];
    var d = dx * dx + dy * dy;
    if (d > 2.4) return false;
    var n = 0.72 + 0.56 * vn(c / 13 + b[0] * 40, r / 13 + b[1] * 40);
    return d < n * n * k;
  }

  // Fluss: kommt von aussen, verbindet die Seen. Einmal als Karte gerechnet (2 = Wasser, 1 = Ufer), Linien in 0..1, Breite in Zellen
  var RIVERS = [
    [[1.05, .765, 8], [.93, .80, 7], [.80, .735, 6], [.68, .78, 5.5], [.565, .735, 5]],
    [[.565, .735, 5], [.45, .66, 4.5], [.35, .60, 4.5], [.205, .545, 4.5]],
    [[.205, .545, 4], [.20, .40, 3.5], [.27, .25, 3.5], [.35, .135, 3.5]],
    [[.80, .735, 4.5], [.86, .55, 4], [.90, .40, 3.5], [.84, .25, 3.5]]
  ], RMAP = null;
  function riverMap() {
    if (RMAP) return RMAP;
    RMAP = new Uint8Array(COLS * ROWS);
    function disc(x, y, r, v) {
      var rr = r * r, y0 = Math.max(0, Math.floor(y - r)), y1 = Math.min(ROWS - 1, Math.ceil(y + r)), x0 = Math.max(0, Math.floor(x - r)), x1 = Math.min(COLS - 1, Math.ceil(x + r)), a, b;
      for (b = y0; b <= y1; b++) for (a = x0; a <= x1; a++) if ((a - x) * (a - x) + (b - y) * (b - y) <= rr && RMAP[b * COLS + a] < v) RMAP[b * COLS + a] = v;
    }
    for (var n = 0; n < RIVERS.length; n++) {
      var L = RIVERS[n];
      for (var k = 0; k < L.length - 1; k++) {
        var P0 = L[Math.max(0, k - 1)], P1 = L[k], P2 = L[k + 1], P3 = L[Math.min(L.length - 1, k + 2)];
        for (var t = 0; t < 1; t += .006) {
          var t2 = t * t, t3 = t2 * t;
          var fx = .5 * (2 * P1[0] + (P2[0] - P0[0]) * t + (2 * P0[0] - 5 * P1[0] + 4 * P2[0] - P3[0]) * t2 + (3 * P1[0] - P0[0] - 3 * P2[0] + P3[0]) * t3);
          var fy = .5 * (2 * P1[1] + (P2[1] - P0[1]) * t + (2 * P0[1] - 5 * P1[1] + 4 * P2[1] - P3[1]) * t2 + (3 * P1[1] - P0[1] - 3 * P2[1] + P3[1]) * t3);
          var x = fx * COLS, y = fy * ROWS, mx = 26 * (fbm(x / 60 + n * 9, y / 60) - .5), my = 26 * (fbm(x / 60 + 31, y / 60 + n * 7) - .5), wd = P1[2] + (P2[2] - P1[2]) * t;
          x += mx; y += my; disc(x, y, wd + 2.2, 1); disc(x, y, wd, 2);
        }
      }
    }
    return RMAP;
  }
  function riverAt(c, r) { return c < 0 || r < 0 || c >= COLS || r >= ROWS ? 0 : riverMap()[r * COLS + c]; }

  // Liefert [Typ, Areal]: Grenzen der Areale sind die Wege, leicht geschwungen
  var OUT = [T_OUT, 0];
  function cell(c, r) {
    if (c < 0 || r < 0 || c >= COLS || r >= ROWS) return OUT;
    var ex = (c - COLS / 2) / (COLS / 2), ey = (r - ROWS / 2) / (ROWS / 2);
    var ed = ex * ex * ex * ex + ey * ey * ey * ey;
    if (ed > 0.62 + 0.3 * fbm(c / 45, r / 45)) { var ro = riverAt(c, r); return ro === 2 ? [T_LAKE, 0] : ro === 1 ? [T_SHORE, 0] : OUT; }
    var i2, wx = c + 34 * (fbm(c / 55, r / 55) - .5), wy = r + 34 * (fbm(c / 55 + 19, r / 55 + 11) - .5);
    var d1 = 1e12, d2 = 1e12, a = 0, b = 0, dx, dy, d;
    for (i2 = 0; i2 < SEEDS.length; i2++) {
      dx = wx - SEEDS[i2][0]; dy = wy - SEEDS[i2][1]; d = dx * dx + dy * dy;
      if (d < d1) { d2 = d1; d1 = d; b = a; a = i2; } else if (d < d2) { d2 = d; b = i2; }
    }
    var pd = Math.sqrt(d2) - Math.sqrt(d1);
    for (i2 = 0; i2 < LAKES.length; i2++) {
      if (inBlob(c, r, LAKES[i2], 1)) return [T_LAKE, a, b, pd];
      if (inBlob(c, r, LAKES[i2], 1.32)) return [T_SHORE, a, b, pd];
    }
    if (pd < 4.4) return [T_PATH, a, b, pd];
    var ri = riverAt(c, r);
    if (ri === 2) return [T_LAKE, a, b, pd];
    if (ri === 1) return [T_SHORE, a, b, pd];
    for (i2 = 0; i2 < GLADES.length; i2++) if (inBlob(c, r, GLADES[i2], 1)) return [T_GRASS, a, b, pd];
    if (villageAt(c, r) >= 0) return [T_GRASS, a, b, pd];
    return [T_TREE, a, b, pd];
  }

  var W = { COLS: COLS, ROWS: ROWS, CW: CW, CH: CH, T_OUT: T_OUT, T_TREE: T_TREE, T_PATH: T_PATH, T_LAKE: T_LAKE, T_GRASS: T_GRASS, T_SHORE: T_SHORE,
    AREAS: AREAS, SEEDS: SEEDS, ORDER: ORDER, RANK: RANK, LAKES: LAKES, GLADES: GLADES, VILLAGES: VILLAGES, villageAt: villageAt, riverAt: riverAt, RIVERS: RIVERS, hash: hash, vn: vn, fbm: fbm, cell: cell };
  if (typeof module !== "undefined" && module.exports) module.exports = W; else root.PTWaldWorld = W;
})(this);
